import React from "react";
import PropTypes from 'prop-types';
import { Col, Card } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { Slider, CircularProgress, Button } from '@material-ui/core';
import AmericoCoverageAmounts from "../../../Helpers/Lists/CoverageAmounts/AmericoCoverageAmounts";
import CurrencyFormat from '../../../Helpers/Formatters/CurrencyFormat';

import '../../Quoter.scss';

export default function AmericoOfferCard(props) {

  const loadingClass = props.loading ? 'loading' : '';
  const offerLoading = props.status && props.statuses && (props.status === props.statuses.WAITING || props.status === props.statuses.TOOLONG || props.status === props.statuses.LONGWAIT);

  return (
    <Col sm={6} md={6} xs={7} className="d-flex colPadding">

      <Card className={"shadow-sm flex-fill mx-auto card-height " + loadingClass} >
        <div className="card-img-top-wrapper" aria-hidden={true} >
          <Card.Img variant="top" src={props.logoUrl} alt="" />
        </div>
        {offerLoading ?  
          <div className="d-flex justify-content-center circular-top">
            <CircularProgress color="primary" />
          </div>
          :
        <Card.Body className="d-flex flex-column">
          <div className="d-flex flex-column align-items-center">
            <div className="card-rate">
              <NumberFormat className="card-rate card-amount" value={props.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            </div>
            <span className="card-carrier-product">{props.productTitle}</span>
            <span className="card-carrier-name">{props.productName}</span>
            <span className="card-term mt-1">{props.term} Year Decreasing Term</span>

            {props.showSlider ?
              (
                <div className="card-slider">
                  <Slider
                    min={props.startAmount ? props.startAmount : 10000}
                    max={parseInt(props.sliderMaxAmount, 10)}
                    step={null}
                    value={parseInt(props.amount, 10)}
                    onChange={(e, v) => props.handleAmountChange(v)}
                    marks={AmericoCoverageAmounts(parseInt(props.sliderMaxAmount, 10), props.startAmount ? props.startAmount : 10000)}
                  />
                </div>
              ) :
              (
                <p className="card-product-description ln-1">{props.productDesc}</p>
              )
            }

            <div className="card-rate">
              <CurrencyFormat className="quote-amount-dollars card-rate" removeSymbol number={parseFloat(props.monthlyRate)} /> /month
            </div>

            {!props.showSlider ?
              (
                <Button color="primary" variant="contained" onClick={props.onNextApply} disabled={props.loading}>Continue</Button>
              ) :
              (
                <Button color="primary" variant="contained" onClick={props.onSetAmount}>Set Amount</Button>
              )
            }

          </div>
        </Card.Body>
        }
      </Card>
    </Col>
  );
};

AmericoOfferCard.propTypes = {
  loading: PropTypes.bool,
  amount: PropTypes.number,
  term: PropTypes.string,
  showSlider: PropTypes.bool,
  productTitle: PropTypes.string,
  productName: PropTypes.string,
  sliderMaxAmount:PropTypes.number,
  handleAmountChange:PropTypes.func,
  productDesc:PropTypes.string,
  monthlyRate:PropTypes.string,
  onNextApply:PropTypes.func,
  onSetAmount:PropTypes.func
};




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/AmericoOfferCard.js